var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40126",
    "data-name": "Group 40126",
    transform: "translate(-8818 -5449)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15282",
    "data-name": "Rectangle 15282",
    width: 16,
    height: 16,
    transform: "translate(8818 5449)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "reload",
    transform: "translate(8819 5451.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36957",
    "data-name": "Path 36957",
    d: "M3.538,16.665a.536.536,0,0,0,.427-.21l.234-.3a5.887,5.887,0,0,0,10.707,2.275.539.539,0,0,0-.9-.595,4.808,4.808,0,0,1-8.759-1.957l.461.355a.538.538,0,0,0,.657-.853L5.09,14.392c-.268-.206-.648-.322-.891-.006L3.112,15.8a.538.538,0,0,0,.426.866Z",
    transform: "translate(-3 -9.276)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36958",
    "data-name": "Path 36958",
    d: "M6.962,8.438a.54.54,0,0,0,.747-.151,4.808,4.808,0,0,1,8.759,1.957l-.461-.355a.538.538,0,0,0-.657.853l1.277.983c.272.209.645.327.891.006l1.088-1.412a.538.538,0,1,0-.853-.656l-.234.3A5.888,5.888,0,0,0,6.811,7.691a.539.539,0,0,0,.151.747Z",
    transform: "translate(-4.718 -5.063)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.ec1e4f6edf61a50bcc081f9ed93df8a6.svg";
export { ForwardRef as ReactComponent };